export const DESKTOP_BRAKPOINT = '1440px'

export const EMAIL = 'support@hublegal.ru'

export const MOBILE_BREAKPOINT = '720px'

export const PHONE = '8 800 101-13-26'

export const TABLET_BREAKPOINT = '1150px'
